export default "__VITE_ASSET__BROie5ri__"